<template>
  <div>
    <h1 class="mb-8 font-bold text-2xl">Liste postes Devis</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="mt-4 block text-gray-700">Trashed:</label>
        <select v-model="form.trashed" class="mt-1 w-full form-select">
          <option :value="null"/>
          <option value="with">With Trashed</option>
          <option value="only">Only Trashed</option>
        </select>
      </search-filter>
      <div class="flex">
      </div>
    </div>
    <div class="bg-white rounded shadow overflow-x-auto">
      <table class="w-full whitespace-no-wrap">
        <tr class="text-left font-bold">
          <th class="px-2 pt-6 pb-4 items-center text-center">N° Order</th>
          <th class="px-2 pt-6 pb-4 items-center text-center">N° Devis</th>
          <th class="px-2 pt-6 pb-4 items-center text-center">Client</th>
          <th class="px-2 pt-6 pb-4 items-center text-center">Phone</th>
          <th class="px-2 pt-6 pb-4 items-center text-center">Panne</th>
          <th class="px-2 pt-6 pb-4 items-center text-center">Brand</th>
          <th class="px-2 pt-6 pb-4 items-center text-center">Model</th>
          <th class="px-2 pt-6 pb-4 items-center text-center">IMEI</th>
          <th class="px-2 pt-6 pb-4 items-center text-center">Prix</th>
          <th class="px-2 pt-6 pb-4 items-center text-center">Remise</th>
          <th class="px-2 pt-6 pb-4 items-center text-center">Date reception</th>
          <th class="px-2 pt-6 pb-4 items-center text-center">Devis</th>
        </tr>
        <tr v-for="repair in repairs.data" :key="repair.id" class="hover:bg-gray-100 focus-within:bg-gray-100 cursor-pointer" >
          <td class="border-t" @click="showForm(repair)">
            <span class="px-4 py-4 flex items-center focus:text-indigo-500" >
              {{ repair.id }}
              <icon v-if="repair.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2"/>
            </span>
          </td>
          <td class="border-t" @click="showForm(repair)">
            <span class="px-4 py-4 flex items-center" tabindex="-1">
              {{ repair.quote_id }}
            </span>
          </td>
          <td class="border-t" @click="showForm(repair)">
            <span class="px-4 py-4 flex items-center" tabindex="-1">
              {{ repair.client }}
            </span>
          </td>
          <td class="border-t" @click="showForm(repair)">
            <span class="px-4 py-4 flex items-center" tabindex="-1">
              {{ repair.client_phone }}
            </span>
          </td>
          <td class="border-t" @click="showForm(repair)">
            <span class="px-4 py-4 flex items-center" tabindex="-1">
              {{ repair.malfunction }}
            </span>
          </td>
          <td class="border-t" @click="showForm(repair)">
            <span class="px-4 py-4 flex items-center" tabindex="-1">
              {{ repair.brand }}
            </span>
          </td>
          <td class="border-t" @click="showForm(repair)">
            <span class="px-4 py-4 flex items-center" tabindex="-1">
              {{ repair.model}}
            </span>
          </td>
          <td class="border-t" @click="showForm(repair)">
            <span class="px-4 py-4 flex items-center" tabindex="-1">
              {{ repair.imei }}
            </span>
          </td>
          <td class="border-t" @click="showForm(repair)">
            <span class="px-4 py-4 flex items-center" tabindex="-1">
              {{ repair.price }}
            </span>
          </td>
          <td class="border-t" @click="showForm(repair)">
            <span class="px-4 py-4 flex items-center" tabindex="-1">
              {{ repair.discount }}
            </span>
          </td>
          <td class="border-t" @click="showForm(repair)">
            <span class="px-4 py-4 flex items-center" :title="repair.creation_date" tabindex="-1">
              {{ repair.created_at }}
            </span>
          </td>
          <td class="border-t">
            <span class="cursor-pointer" title="Imprimer le devis" @click="printQuote(repair.id)">
              <svg class="h-10 w-10 mx-auto text-indigo-600 hover:text-indigo-800" xmlns="http://www.w3.org/2000/svg" fill="none"
                   viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"/>
              </svg>
            </span>
          </td>
        </tr>
        <tr v-if="repairs.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">No reparation found.</td>
        </tr>
      </table>
      <!-- Detail Modal -->
      <jet-dialog-modal max-width="4xl" :show="detailForm" :closeable="false" @close="detailForm = false">
        <template #title>
          Detail Devis N° {{ activeRepair.quote_id }}
        </template>
        <template #content>
          <div class="mt-4">
            <div class="flex flex-wrap">
              <text-input v-model="activeRepair.imei" disabled="disabled" class="px-3 pb-6 w-full lg:w-1/4" label="IMEI"/>
              <text-input v-model="activeRepair.created_at" disabled="disabled" class="px-3 pb-6 w-full lg:w-1/4" label="Date Reception"/>
              <text-input v-model="activeRepair.client" disabled="disabled" class="px-3 pb-6 w-full lg:w-1/4" label="Client"/>
              <text-input v-model="activeRepair.client_phone" disabled="disabled" class="px-3 pb-6 w-full lg:w-1/4" label="Telephone"/>
              <text-input v-model="activeRepair.model" disabled="disabled" class="px-3 pb-6 w-full lg:w-1/4" label="Model"/>
              <text-input v-model="activeRepair.brand" disabled="disabled" class="px-3 pb-6 w-full lg:w-1/4" label="Brand"/>
              <text-input v-model="activeRepair.malfunction" disabled="disabled" class="px-3 pb-6 w-full lg:w-1/4" label="Panne"/>
              <text-input v-model="activeRepair.tech_name" disabled="disabled" class="px-3 pb-6 w-full lg:w-1/4" label="Technicien"/>
              <text-input v-model="activeRepair.agency" disabled="disabled" class="px-3 pb-6 w-full lg:w-1/4" label="Agence"/>
              <text-input v-model="activeRepair.price" disabled="disabled" class="px-3 pb-6 w-full lg:w-1/4" label="Prix"/>
              <text-input v-model="quote.discount" type="number" :error="errors.discount" @input.native="calculPrice" class="px-3 pb-6 w-full lg:w-1/4" label="Remise"/>
              <text-input v-model="quote.priceAfterDiscount" disabled="disabled" class="px-3 pb-6 w-full lg:w-1/4" label="prix apres remise"/>
              <div class="px-3 pb-6 w-full lg:w-1/2">
                <textarea-input  v-model="activeRepair.comment" disabled="disabled" label="Commentaire"/>
              </div>
              <div class="px-3 pb-6 w-full lg:w-1/2">
                <textarea-input  v-model="activeRepair.client_comment" disabled="disabled" label="Commentaire client"/>
              </div>
            </div>
          </div>
        </template>
        <template #footer>
          <jet-secondary-button @click.native="detailForm = false">
            Fermer
          </jet-secondary-button>
          <jet-button class="mr-10" :class="{ 'opacity-25': processing }" :disabled="processing" @click.native="updateQuote(null)">
            Sauvegarder
          </jet-button>
          <jet-button class="bg-green-600 hover:bg-green-500 focus:border-green-700 focus:shadow-outline-green" @click.native="updateQuote('accept')"
                      :class="{ 'opacity-25': processing }" :disabled="processing">
            Accepter
          </jet-button>
          <jet-danger-button class="focus:shadow-outline-green" :class="{ 'opacity-25': processing }" :disabled="processing" @click.native="updateQuote('reject')">
            Refuser
          </jet-danger-button>
          <jet-button class="bg-orange-400 hover:bg-orange-400 focus:border-orange-400 focus:shadow-outline-green"
                      :class="{ 'opacity-25': processing }" :disabled="processing" @click.native="updateQuote('cancel')">
            Annuler
          </jet-button>
        </template>
      </jet-dialog-modal>
    </div>
    <pagination :links="repairs.links"/>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Layouts/AppLayout'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'
import Pagination from '@/Shared/Pagination'
import throttle from "lodash/throttle";
import pickBy from "lodash/pickBy";
import JetDialogModal from '@/Jetstream/DialogModal'
import JetSecondaryButton from '@/Jetstream/SecondaryButton'
import TextInput from "@/Shared/TextInput"
import JetButton from '@/Jetstream/Button'
import TextareaInput from "@/Shared/TextareaInput"
import JetDangerButton from '@/Jetstream/DangerButton'



export default {
  metaInfo: {title: 'Liste Devis'},
  layout: Layout,
  components: {
    Icon,
    SearchFilter,
    Pagination,
    JetDialogModal,
    JetSecondaryButton,
    TextInput,
    JetButton,
    TextareaInput,
    JetDangerButton
  },
  props: {
    repairs: Object,
    filters: Object,
    errors: Object,
  },
  data() {
    return {
      detailForm: false,
      sending: false,
      processing: false,
      activeRepair: {
        quote_id: null,
        imei: null,
        creation_date: null,
        client: null,
        client_phone: null,
        model: null,
        brand: null,
        malfunction: null,
        tech_name: null,
        agency: null,
        price: null,
        comment: null,
        client_comment: null,
      },
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
      quote: {
        quoteId: null,
        repairId: null,
        discount: null,
        priceAfterDiscount: 0,
      }
    }
  },
  watch: {
    form: {
      handler: throttle(function () {
        let query = pickBy(this.form)
        this.$inertia.replace(this.route('quote.list', Object.keys(query).length ? query : {remember: 'forget'}))
      }, 150),
      deep: true,
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    calculPrice() {
      let discount = this.quote.discount
      if (isNaN(discount) || discount > this.activeRepair.price) {
        alert('error')
        return
      }
      this.quote.priceAfterDiscount = this.activeRepair.price - discount
    },
    showForm(repair) {
      this.detailForm = true
      this.activeRepair = repair
      this.quote.quoteId = repair.quote_id
      this.quote.repairId = repair.id
      this.quote.discount = repair.discount
      this.quote.priceAfterDiscount = repair.price
      if (repair.discount != null) {
        this.calculPrice()
      }
    },
    updateQuote(action) {
      const data = new FormData()
      data.append('quote', JSON.stringify(this.quote) || '')
      data.append('action', action || null)
      this.$inertia.post(this.route('quote.update'), data, {
        preserveScroll: true,
        onStart: () => this.processing = true,
        onFinish: () => this.processing = false,
        onSuccess: () => {
          if (Object.keys(this.$page.props.errors).length === 0) {
            this.detailForm = false
            if (action === 'accept') {
              this.printInvoice(this.quote.repairId)
            } else if (action === 'reject') {
              this.printBl(this.quote.repairId)
            }
          }
        },
        onError: (errors) => {
          alert(errors)
        },
      })
    },
    printQuote(id) {
      window.open(this.route('quote.print', id), "_blank");
    },
    printInvoice(id) {
      window.open(this.route('quote.print', id) + '?invoice=1', "_blank");
    },
    printBl(id) {
      window.open(this.route('quote.print-bl', id), "_blank");
    },
  },
}
</script>
